import React from 'react';

import ErrorIcon from '@atlaskit/icon/core/status-error';
import { CheckboxOption, type OptionProps, type OptionType } from '@atlaskit/select';
import { R400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { StyledInvalidCheckboxOption } from '../../../../common/ui/picker/styled';

export const Option = (props: OptionProps<OptionType, true>): React.JSX.Element => {
	if (props.data?.invalid) {
		return (
			<StyledInvalidCheckboxOption>
				<CheckboxOption {...props} />
				{/* @ts-ignore react-select unsupported props */}
				<Tooltip content={props.selectProps.fieldInvalidLabel}>
					<ErrorIcon label="Test" color={token('color.icon.danger', R400)} />
				</Tooltip>
			</StyledInvalidCheckboxOption>
		);
	}

	return <CheckboxOption {...props} />;
};
